import React from "react";
import { createPortal } from "react-dom";
import Component from "@reach/component-component";

var Portal = function Portal(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? "reach-portal" : _ref$type;
  return React.createElement(Component, {
    getRefs: function getRefs() {
      return { node: null };
    },
    didMount: function didMount(_ref2) {
      var refs = _ref2.refs,
          forceUpdate = _ref2.forceUpdate;

      refs.node = document.createElement(type);
      document.body.appendChild(refs.node);
      forceUpdate();
    },
    willUnmount: function willUnmount(_ref3) {
      var node = _ref3.refs.node;

      document.body.removeChild(node);
    },
    render: function render(_ref4) {
      var node = _ref4.refs.node;

      return node ? createPortal(children, node) : null;
    }
  });
};

export default Portal;


//////////////////
// WEBPACK FOOTER
// ./~/@reach/portal/es/index.js
// module id = 578
// module chunks = 3